export default __webpack_public_path__ + "static/media/Thief's Armbands of the Sundered Crown.a498a805.jpg";